import { render, staticRenderFns } from "./CustomAlert.vue?vue&type=template&id=37b29595&scoped=true"
import script from "./CustomAlert.vue?vue&type=script&lang=js"
export * from "./CustomAlert.vue?vue&type=script&lang=js"
import style0 from "./CustomAlert.vue?vue&type=style&index=0&id=37b29595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b29595",
  null
  
)

export default component.exports